<!--
  * Path: src/features/browser/components/SecondaryContextProvider.vue
  * Task: Provides the secondary entity context to all child form components.
  * Update: Made context dynamic (secondary vs preview) to reuse the panel inside the Tertiary Modal.
-->
<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { provide, computed } from 'vue';
import { useWorkspaceStore } from '@/store/workspace';
import { FormContextKey } from '@/core/keys';

const props = defineProps({
  contextType: { type: String, default: 'secondary' } // Accepts 'secondary' or 'preview'
});

const workspaceStore = useWorkspaceStore();

// Provide a localized context purely for the wrapped component tree.
// CRITICAL: We MUST use computed() here to retain reactivity across the provide/inject boundary.
provide(FormContextKey, {
  entity: computed(() => props.contextType === 'preview' ? workspaceStore.previewEntity : workspaceStore.secondarySelectedEntity),
  entityId: computed(() => props.contextType === 'preview' ? workspaceStore.previewEntityId : workspaceStore.secondarySelectedEntityId),
  // Previews are strictly read-only to prevent deep-nested editing chaos
  isLocked: computed(() => props.contextType === 'preview' ? true : workspaceStore.secondaryIsLocked),
  isSecondary: true,
  isDraft: false
});
</script>
